module.exports = __webpack_public_path__ + "img/a1@2x.2c3d34da.png";